module.exports = __webpack_public_path__ + "static/media/no-profile-img.c2ce20e8.png";